'use strict';

const _ = require('underscore');
const Backbone = require('backbone');
const Mn = require('backbone.marionette');
const ElementAction = require('system/domain/action/element');
const TagStore = require('system/domain/repository/tag');
const TagListView = require('system/ui/view/detail/tag-list');
const TagSearchView = require('system/ui/view/detail/tag-search');
const TagBulkEditModalViewTemplate = require('system/ui/template/modal/tag-bulk-edit.hbs');

module.exports = Mn.View.extend({
    template: TagBulkEditModalViewTemplate,
    regions: {
        currentTags: '.tags-current',
        addTags: '.tags-add'
    },
    ui: {
        tagInput: '.tag-input',
        doneButton: '.done',
        cancelButton: '.cancel'
    },
    events: {
        'click @ui.doneButton': 'done',
        'click @ui.cancelButton': 'cancel'
    },

    initialize: function(params) {
        _.bindAll(this, '_addTag');
        this._nodes = params.nodes;
        this._context = params.context;

        const tagMap = {};
        _.each(this._nodes, function(n) {
            _.each(n.get('tags'), function(tagId) {
                tagMap[tagId] = true;
            });
        });
        this._currentTags = new Backbone.Collection(
            TagStore.getTags({
                context: this._context
            }).getByIds(_.keys(tagMap))
        );
        this._addedTags = new Backbone.Collection();
        this._removedTags = new Backbone.Collection();
    },

    onRender: function() {
        const currentTagsView = new TagListView({
            collection: this._currentTags,
            context: this._context,
            edit: true
        });
        currentTagsView.on('remove:tag', _.bind(function(tag) {
            this._currentTags.remove(tag, {silent: true});
            this._removedTags.add(tag);
        }, this));
        this.showChildView('currentTags', currentTagsView);
        this.showChildView('addTags', new TagListView({
            collection: this._addedTags,
            context: this._context,
            edit: true
        }));
        (new TagSearchView({
            el: this.ui.tagInput,
            context: this._context,
            onSelect: this._addTag,
            onCreate: this._addTag
        })).render();

        return this;
    },

    _addTag: function(tag) {
        this._addedTags.add(tag);
    },

    show: function() {
        this.$('.modal').modal('show');
    },

    done: function() {
        this._removedTags.each(function(tag) {
            ElementAction.removeTagFromNode({
                context: this._context,
                tag: {id: tag.id},
                node: _.map(this._nodes, function(n){
                    return n.toJSON();
                })
            });
        }, this);
        this._addedTags.each(function(tag) {
            ElementAction.addTagToNode({
                context: this._context,
                tag: {id: tag.id},
                node: _.map(this._nodes, function(n){
                    return n.toJSON();
                })
            });
        }, this);
        this.$('.modal').modal('hide');
        this.remove();
    },

    cancel: function() {
        this.$('.modal').modal('hide');
        this.remove();
    }
});



// WEBPACK FOOTER //
// ./system/ui/view/modal/tag-bulk-edit.js